export const SET_ASSISTANCE_SERVICE_SELECTED: string = `ASSISTANCE/SET_ASSISTANCE_SERVICE_SELECTED`;
